import { Stack, Box } from "@mui/material";
import { AccountBox } from "@mui/icons-material";

export default function LogListItem() {
  return (
    <Stack
      flexDirection={"row"}
      alignItems={"center"}
      gap={1}
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <AccountBox 
          sx={{
            fontSize: "24px",
            width: "24px",
            height: "24px",
            color: "white",
            display: "block",
          }}
        />
      </Box>
      회원 접속로그
    </Stack>
  );
}
